/**
 * Responsive font sizing for the couple names.
 *
 * Long names (including one or two surnames) must never overflow on
 * small screens, while short names should stay dramatic. This helper
 * returns a CSS `clamp()` value tuned to the rendered name length so
 * the invitation works automatically for any couple — no manual CSS
 * edits are needed after swapping in real names.
 */

type NameVariant = 'hero' | 'closing';

export function nameFontSize(name: string, variant: NameVariant = 'hero'): string {
  const length = name.trim().length;

  if (variant === 'closing') {
    if (length <= 8) return 'clamp(1.9rem, 6.5vw, 3.25rem)';
    if (length <= 14) return 'clamp(1.7rem, 5.5vw, 2.75rem)';
    if (length <= 22) return 'clamp(1.5rem, 5vw, 2.4rem)';
    return 'clamp(1.35rem, 4.5vw, 2.1rem)';
  }

  if (length <= 8) return 'clamp(2.75rem, 10vw, 6.5rem)';
  if (length <= 14) return 'clamp(2.5rem, 8.5vw, 5rem)';
  if (length <= 22) return 'clamp(2.25rem, 7.5vw, 4.25rem)';
  return 'clamp(2rem, 6.5vw, 3.5rem)';
}